import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-checkin-details',
  templateUrl: './checkin-details-row.component.html',
  styleUrls: ['./checkin-details-row.component.scss'],
})
export class CheckinDetailsComponent {
  constructor(
    public dialogRef: MatDialogRef<CheckinDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
